import { Platform } from "react-native";

/**
 * Custom implementation similar to Platform.select, but support for more granular platform selection.
 *
 * One of the use cases for CustomPlatform.* is when using it in the index.ts files to select the
 * appropriate file for the target platform, making it possible to have a single Metro instance
 * running for all platforms during development.
 */
const CustomPlatform = {
  select: <V>({
    native,
    ios,
    android,

    tv,
    tvOS,
    androidTV,

    web,
    default: defaultValue,
  }: {
    native?: V; // native = ios || android
    ios?: V;
    android?: V;

    tv?: V; // tv = tvOS || androidTV
    tvOS?: V;
    androidTV?: V;

    web?: V;

    default?: V;
  }): V => {
    if (Platform.isTV) {
      return (Platform.select({
        android: androidTV,
        ios: tvOS,
      }) ??
        tv ??
        defaultValue) as V;
    }

    if (Platform.OS === "web") {
      return (web ?? defaultValue) as V;
    }

    return (Platform.select({
      android,
      ios,
    }) ??
      native ??
      defaultValue) as V;
  },
};

export default CustomPlatform;
